import { CreatePhaseComponent } from './../../../phase/components/create/create.component';
import { WorkFlowService } from './../../services/work-flow.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { EditPhaseComponent } from '../../../phase/components/edit/edit.component';

@Component({
  selector: 'app-workflow-details',
  templateUrl: './workflow-details.component.html',
  styleUrls: ['./workflow-details.component.scss'],
})
export class WorkflowDetailsComponent implements OnInit {
  model: any;
  finish: boolean;
  constructor(
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private service: WorkFlowService,
    private diag: NbDialogService
  ) {}

  ngOnInit() {
    const workFlowId = this.activatedRoute.snapshot.params.id;

    this.service.getById(workFlowId).subscribe((res) => {
      this.model = res;
      if (this.model.phase == null) {
        this.model.phase = [{}];
      }
      this.finish = true;
    });
  }

  addNewPhase(id: number) {
    // const route = ['admin/workflow/phases/new/' + id];
    //  this.ref.close();
    // this.route.navigate(route);
    this.diag.open(CreatePhaseComponent, { context: { workflowId: id } }).onClose.subscribe((res) => {
      if (res === 'true') this.ngOnInit();
    });
  }

  addNewActivity(id: number) {
    const route = ['admin/workflow/activity/new/' + id];
    // this.ref.close();
    this.route.navigate(route);
  }

  editphase(id) {
    //   this.ref.close();

    this.diag.open(EditPhaseComponent, { context: { phaseId: id } }).onClose.subscribe((res) => {
      if (res === 'true') this.ngOnInit();
    });
    // this.route.navigate(['admin/workflow/phase/edit/' + id]);
  }
}
